import { toRef } from 'vue'

// It appears that Vue3 does not support mutating props whatsoever.
// This is probably good, but it doesn't work for us at the moment
// since we pass props in via a non-vue DOM component and sometimes
// those props need to be massaged.
// This method essentially creates a copy of those props (completely
// decoupled from the original) and turns them into refs that can be
// mutated.
// Essentially, if you're in a top-level component and you need to
// mutate props, you should call this method and use the return value.
// This should never be used in a child component, as you should never
// mutate props in a child component.
//
// Example:
//
//   const props = defineProps({ ... })
//   const externalProps = destructureExternalProps(props)
//   // OR
//   const { prop1, prop2 } = destructureExternalProps(props)
export const destructureExternalProps = (props) => {
  const propKeys = Object.keys(props)

  const copyAndRefProp = (key) => toRef(structuredClone(props[key]))

  return Object.fromEntries(propKeys.map((key) => [key, copyAndRefProp(key)]))
}
